import type { TextInputProps } from '@_/ui';
import type { FormComponentProps } from './types.ts';
import { TextInput } from '@_/ui';
import { useFieldContext } from './BaseForm.ts';
import { usePropsFromField } from './utils.ts';

export function FormTextInput(
  props: FormComponentProps<Omit<TextInputProps, 'onChange' | 'value'>>
) {
  const field = useFieldContext<string>();

  return (
    <TextInput
      key={field.name}
      {...usePropsFromField(props, field)}
      onBlur={field.handleBlur}
      onChange={e => field.handleChange(e.target.value)}
      value={field.state.value}
    />
  );
}
